import React, {
  useEffect,
  useState,
  forwardRef,
  useRef,
  useImperativeHandle,
  useMemo,
} from "react";
import { useOutletContext } from 'react-router-dom';
import Timer from "../Timepicker";
import { connect, useDispatch, useSelector } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import "../../assets/css/Customform.css";
import Form from "react-bootstrap/Form";
import {
  TicketTagManagement,

} from '../../redux/actions/TicketAction.js'
import TimePicker from "react-times";
import moment from "moment";
import "react-times/css/material/default.css";
import "react-times/css/classic/default.css";
import { BsFillHexagonFill } from "react-icons/bs";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import Select from "react-select";
import EventEmitter from "../../utils/EventEmitter";
import Regex_ from '../../utils/regex'
import Format from '../../utils/format-text'
import {
  CustomformUpdate,
  CustomFormCreate,
} from "../../redux/actions/Customform";
import Dialogbox from "../Dialogbox";
import { GetLeadStataus, GetSource, GetTimezone, Getsearch } from '../../redux/actions/Asterleads'
import { triggerdispostate, callLeadDetail, triggerreqpopup } from "../../redux/background/BackgroundAction";
import { Decode, Encode } from "../../utils/EncodeDecode";
import { useNavigate } from 'react-router'
import fromat from '../../utils/format-text'
import AsyncSelect from 'react-select/async';
import ChatBox from "../chatBox.js";
import { FiNavigation } from "react-icons/fi";
import { CiChat2 } from "react-icons/ci";
import { currenttime_provider } from "../../utils/Helper.js";
function CustomForm(props, ref) {
  const { triggerCallScreenFunction, outletData, isMobile } = useOutletContext();
  let { phone_number } = useParams();
  phone_number = Decode(phone_number)
  let [loadvalues, setloadvalues] = useState([])
  let [datetimemodel, setdatetimemodel] = useState([])
  const [timezone, settimezone] = useState([])
  let state_value = useSelector((state) => state);
  const [validate, setvalidate] = useState(false);
  let [chatdata, setchatdata] = useState({})
  let campaigninfo = JSON.parse(localStorage.getItem("selectedCampaign_data"));
  let teaminfo = JSON.parse(localStorage.getItem("Teaminfo"));
  let Dispatch = useDispatch();
  let navigate = useNavigate()
  const location = useLocation()
  const [customField, setcustomField] = useState([]);
  const [formdata, setformdata] = useState({});
  const [cloneformdata, setcloneformdata] = useState({});
  const [catagory, setcatagory] = useState([]);
  const [dispo, setdispo] = useState([]);
  const [updatedata, setupdatedata] = useState({});
  const [templetedata, settempletedata] = useState({});
  const [leadcreatestatus, setleadcreatestatus] = useState(false);
  const [regexvalidation, setregexvalidation] = useState({});
  const [textcount, settextcount] = useState({})
  const [notepadtext, setnotepadtext] = useState('')
  const [leadstatus, setleadstatus] = useState([])
  const [flagnumber, setflagnumber] = useState(false)
  const [modeltype_ph_num, setmodeltype_ph_num] = useState([])
  // const [wordCount, setwordCount] = useState(255)
  const [Listdata, setlistdata] = useState(
    JSON.parse(localStorage.getItem("list")).map((elm) => {
      return { label: elm.list_id, value: elm.list_id.toString() };
    })
  );
  const [tags, settags] = useState([])
  const [source, setsource] = useState([])
  const [popupdata, setpopupdata] = useState({
    open: false,
    Type: "Notification_bar",
    field: [],
    title: "update Lead ",
    Message: "lead updated successfully!!! ",
  });

  const [requiredpopupdata, setrequiredpopupdata] = useState({
    open: false,
    Type: "Notification_bar",
    field: [],
    title: "Require field error",
    Message: "please fill require field!!! ",
  });
  let AppPermission
  if (localStorage.getItem('config')) {
    AppPermission = JSON.parse(localStorage.getItem('config')).data.projects[0].userPermission
  }
  // useMemo(() => {
  //   if (location.pathname === '/leads/create') {
  //     console.log("jhschjsdbchjsdgbhjcshchsc")
  //     phone_number=state_value.background.socket_message.phonenumber
  //   }
  // }, [])
  useEffect(() => {

    if (props.triggerdispo) {

      if (isMobile) {
        setTimeout(() => {
          update(true)
          props.closedispo()
        }, 500);
      } else {
        update(true)
        props.closedispo()
      }

    }
  }, [props.triggerdispo])
  useMemo(() => {
    mounted();
    Dispatch(triggerdispostate(false));
  }, [phone_number, props.formdatas]);

  // useImperativeHandle(ref, () => ({
  //   updateapi() {
  //     update();
  //   },
  // }));

  useEffect(() => {
    if (props.savebutton) {
      console.log("444444444444444", "9999999999999999999")
      update();
    }
  }, [props.savebutton]);
  useEffect(() => {

    if (state_value.background.triggerreqpopup) {
      console.log("3333333333333333333333333", "9999999999999999999")
      update()
      Dispatch(triggerreqpopup(false));
    }
  }, [state_value.background.triggerreqpopup]);

  useEffect(() => {
    let campaigndetailslocalstorage = JSON.parse(localStorage.getItem("campaigndetails"))
    if (state_value.background.triggerdispo && !campaigndetailslocalstorage.auto_dispo) {
      console.log("22222222222222222222222", "9999999999999999999")
      update();
    } else {
      Dispatch(triggerdispostate(false));
    }
  }, [state_value.background.triggerinitiate]);
  useEffect(() => {
    localStorage.setItem("formvalidate", validate)
  }, [validate])
  useMemo(() => {

    let emptyobj = { fields: [] };
    emptyobj.fields.push({
      name: 'modified_by',
      value: localStorage.getItem("user")
    });
    for (const key in formdata) {
      if (key === "modified_date") {
        formdata[key] = currenttime();
      }
      if (
        key !== "lead_id" &&
        key !== "phone_number" &&
        key !== "list_id" &&
        key !== "hopper_status"
        //  &&
        // key !== "disposition"
        && key !== "subdisposition" && key !== "deleted" &&
        key !== 'modified_by' && key !== 'created_by' && key !== 'created_at'
      ) {

        let datedate = new Date(formdata[key])
        if (Object.prototype.toString.call(datedate) === "[object Date]" && key !== "modified_date") {
          if (!isNaN(datedate.getTime()) && datetimemodel.includes(key)) {
            const yyyy = datedate.getFullYear();
            let mm = datedate.getMonth() + 1;
            let dd = datedate.getDate();
            let hh = datedate.getHours();
            let MM = datedate.getMinutes();
            let ss = datedate.getSeconds();
            if (dd < 10) dd = "0" + dd;
            if (mm < 10) mm = "0" + mm;
            if (hh < 10) hh = "0" + hh;
            if (MM < 10) MM = "0" + MM;
            if (ss < 10) ss = "0" + ss;

            const formattedToday =
              yyyy + "-" + mm + "-" + dd + " " + hh + ":" + MM + ":" + ss;
            emptyobj.fields.push({
              name: key,
              value: formattedToday,
            });
          } else {
            emptyobj.fields.push({
              name: key,
              value: formdata[key],
            });
          }
        }

      }
      if (leadcreatestatus === true) {
        if (key === "phone_number" || key === "list_id") {
          emptyobj.fields.push({
            name: key,
            value: formdata[key],
          });
        }
        if (key === "modified_date" && props.formdatas.action === "create") {
          emptyobj.fields.push({
            name: key,
            value: currenttime(),
          });
        }
        if (key === "disposition" && props.formdatas.action === "create") {
          emptyobj.fields.push({
            name: key,
            value: "new",
          });
        }
        if (key === "deleted") {
          emptyobj.fields.push({
            name: key,
            value: "false",
          });
        }
        if (key === 'isclosed') {
          emptyobj.fields.push({
            name: key,
            value: formdata[key],
          });
        }
        if (leadcreatestatus && key === 'created_by') {
          emptyobj.fields.push({
            name: key,
            value: localStorage.getItem('user'),
          })
        }
        if (leadcreatestatus && key === 'created_at') {
          emptyobj.fields.push({
            name: key,
            value: currenttime(),
          })
        }
        if (leadcreatestatus && key === 'hopper_status') {
          emptyobj.fields.push({
            name: key,
            value: "0",
          })
        }
      }
    }
    setupdatedata(emptyobj);
  }, [formdata]);

  useEffect(() => {
    for (let i = 0; i < customField.length; i++) {
      let elm = customField[i];
      if (
        formdata[`${elm.model}`] !== "" &&
        formdata[`${elm.model}`] !== null &&
        formdata[`${elm.model}`] !== undefined
      ) {
        if (elm.fieldType === "Checkbox") {
          handleChangedata(elm, {
            checked: formdata[`${elm.model}`],
            value: elm.model,
          });
        } else {
          handleChangedata(elm, { value: formdata[`${elm.model}`] });
        }
      }
    }
  }, [cloneformdata]);

  function currenttime() {
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1;
    let dd = today.getDate();
    let hh = today.getHours();
    let MM = today.getMinutes();
    let ss = today.getSeconds();
    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;
    if (hh < 10) hh = "0" + hh;
    if (MM < 10) MM = "0" + MM;
    if (ss < 10) ss = "0" + ss;

    const formattedToday =
      yyyy + "-" + mm + "-" + dd + " " + hh + ":" + MM + ":" + ss;
    return formattedToday;
  }
  function gettag() {

    Dispatch(TicketTagManagement())
      .then((response) => {
        if (response.statusCode === 200) {
          let tag = response.data.map((elm) => {
            return { label: elm.name, value: elm.name }
          })
          settags(tag)
        }
      })
      .catch((err) => {
        console.log(err, "error ticket tag fetching");
        EventEmitter.emit('error-message-getter', {
          action: 'fetch',
          module: 'tag',
        })
      })
  }
  function Getdispo() {

    let dispo = JSON.parse(localStorage.getItem('dispo')).map((elm) => {
      return { label: elm, value: elm }
    })
    console.log(dispo, "dispodispodispo")
    setdispo(dispo)


  }

  function sourcefn() {
    Dispatch(GetSource()).then((res) => {
      if (res.statusCode == 200) {
        let sourcedata = res.data.map((elm) => {
          return { label: elm.name, value: elm.name }
        })
        setsource(sourcedata)
      } else if (res.statusCode == 204) {
        setcustomField((set) => {
          let getindexfield = set.findIndex((Elm) => Elm.model == "source")
          if (getindexfield !== -1) {
            set[getindexfield].required = false
          }
          return set
        })
      }
    }).catch((err) => {
      console.log(err, "error in sourcefn function")
      EventEmitter.emit('error-message-getter', {
        action: 'Source',
        module: 'lead',
      })
    });
  }

  function teamBasedRequired(fields, value) {
    const customFields = fields.map((items) => {
      if (items.model === value) {
        items.required = teamType(value);
      }
      return items
    })
    return customFields;
  }

  function teamType(value) {
    if (Object.keys(teaminfo).length > 0) {
      return teaminfo.type === value || teaminfo.type === 'all'
    }
    return false;
  }

  function mounted() {
    Dispatch(GetTimezone())
      .then((res) => {
        if (res.statusCode === 200) {
          let timezone_data = res.data.map(elm => {
            return {
              label: elm.zone_name,
              value: elm.zone_name
            }
          })
          settimezone(timezone_data)
        }


      })
      .catch((error) => {
        console.log(error, "error in mounted function")
        EventEmitter.emit('error-message-getter', {
          action: 'fetch',
          module: 'time zone',
        })

      });
    gettag()
    Getdispo()
    let newlead = {};
    Dispatch(GetLeadStataus()).then(function (response) {
      if (response.statusCode === 200) {
        setleadstatus(response.data)
        let leadstatus_ = response.data.map((elm) => {
          if (elm.is_closed === "Y") {
            return { label: elm.name, value: elm.name, isclosed: true }
          } else {
            return { label: elm.name, value: elm.name, isclosed: false }
          }

        })
        setleadstatus(leadstatus_)
      } else if (response.statusCode == 204) {
        setleadstatus([])
      }
    }).catch((err) => {
      console.log(err, "error in mounted function")
      EventEmitter.emit('error-message-getter', {
        action: 'status',
        module: 'lead',
      })
    })

    const customFields = teamBasedRequired(props.statedata.fields, "source");
    setcustomField(customFields);
    let payload = {
      template_name: campaigninfo.template_name,
      type: campaigninfo.type,
      phone_number: phone_number,
    };
    let modeldata = []
    let validateobj = {}
    let txtcount = {}
    setmodeltype_ph_num((set) => {
      set = []
      return set
    })
    props.statedata.fields.forEach((element) => {

      validateobj[`${element.model}`] = false
      txtcount[`${element.model}`] = 255
      if (element.model === "phone_number" || element.model === "user") {
        if (location.pathname === '/leads/create') {
          if (state_value.background.socket_message.phonenumber != "" && state_value.background.socket_message.phonenumber != undefined &&
            state_value.background.socket_message.phonenumber !== null && state_value.background.socket_message.phonenumber) {
            setflagnumber(true)
          }
          phone_number = state_value.background.socket_message.phonenumber
        }
        if (localStorage.getItem(`setStatic_number`) !== null) {
          phone_number = localStorage.getItem(`setStatic_number`)
        }
        newlead["phone_number"] = phone_number;
        newlead["user"] = localStorage.getItem("user");
      } else {
        newlead[element.model] = "";
        if ((element.fieldType == "TextInput" || element.fieldType == "LongTextInput") && element.hasDefault && element.show_on_popup) {
          if (element.default != null && element.default != "") {
            newlead[element.model] = element.default
          }
        }
      }

      if (element.fieldType === "DatetimePicker") {
        modeldata.push(element.model)
      }


      if (element.type == "phone_number" && element.model !== "phone_number") {
        if (props.operation) {
          setmodeltype_ph_num((set) => {
            set.push(element.model)
            return set
          })
        } else {
          if ((props?.formdatas?.data?.status === 204 || props?.formdatas?.data.statusCode === 200) && props.formdatas.data.data[0].others[element.model] == "") {
            setmodeltype_ph_num((set) => {
              set.push(element.model)
              return set
            })
          }
        }
      }
    });
    settextcount(txtcount)
    setregexvalidation(validateobj)
    setdatetimemodel(modeldata)
    let res = props.formdatas;
    console.log(res, "kkkkkkkkkkkkkkkkkkkkoooooooooooooooo")
    if (res.status === 204) {
      setleadcreatestatus(true);
      setpopupdata((set) => {
        set.title = "create lead";
        set.Message = "lead created successfully!!! ";
        return {
          ...set,
        };
      });
      setformdata(newlead);
      settempletedata(payload);
    } else if (res.data.statusCode === 200) {
      payload.id = res.data.data[0].others.lead_id;


      settempletedata(payload);
      setleadcreatestatus(false);
      setformdata(res.data.data[0].others);
      res.data.data[0].basic.id = res.data.data[0].others.lead_id;
    }

    let customField_data = props.statedata.fields;
    let catagory_array = [];
    let child_fielddata = customField_data.filter(
      (elm) => elm.link_type === "Child"
    );
    let parent_fielddata = customField_data.filter(
      (elm) => elm.link_type === "Parent"
    );

    let obj = {};
    for (let i = 0; i < customField_data.length; i++) {
      const element = customField_data[i].catagory_value;

      if (
        customField_data[i].model === "lead_id"
      ) {
        catagory_array.splice(0, 0, element);
      } else if (!catagory_array.includes(element)) {
        catagory_array.push(element);
      }
      catagory_array = [...new Set(catagory_array)];


      if (
        (customField_data[i].link_type === "Child" &&
          customField_data[i].is_link) ||
        customField_data[i].disabled || customField_data[i].model === "associated_id" ||
        customField_data[i].model === "modified_date" ||
        customField_data[i].model === "modified_by" ||
        customField_data[i].model === "lead_id" ||
        customField_data[i].model === "phone_number" ||
        customField_data[i].model === "list_id" ||
        customField_data[i].model === "hopper_status"
        ||
        (customField_data[i].model === "disposition" && location.pathname === '/leads/create')
      ) {
        if (customField_data[i].model === "phone_number") {
          customField_data[i]["visible"] = true;
          customField_data[i]["disabled"] = true; //last work
        } else if ((customField_data[i].model === "associated_id" && customField_data[i].disabled)) {
          customField_data[i]["visible"] = true;
          customField_data[i]["disabled"] = true;
        } else if ((customField_data[i].model === "associated_id" && !customField_data[i].disabled)) {
          customField_data[i]["visible"] = true;
          customField_data[i]["disabled"] = false;
        } else {
          customField_data[i]["visible"] = false; //last work
        }


        if (res.status === 204) {
          if (
            (customField_data[i].model === "list_id" ||
              customField_data[i].model === "email" || customField_data[i].model === "phone_number") && res.action === "create"
          ) {
            customField_data[i]["visible"] = true;
            customField_data[i].disabled = false;
            customField_data[i].readonly = false;
          } else if (customField_data[i].model === "list_id" ||
            customField_data[i].model === "email" && res.action !== "create") {
            customField_data[i]["visible"] = true;
            customField_data[i].disabled = false;
            customField_data[i].readonly = false;
          }

          if (
            customField_data[i].model === "user" ||
            customField_data[i].model === "list_id"
          ) {
            if (customField_data[i].fieldType === "TextInput") {
              customField_data[i].fieldType = "SelectList";
            }
            // SelectList
          }
        }
      } else if (
        customField_data[i].link_type === "" ||
        customField_data[i].link_type === "Parent"
      ) {

        customField_data[i]["visible"] = true;
      }
    }

    parent_fielddata.forEach((elm) => {
      child_fielddata.forEach((elem) => {
        if (elem.linked_to === elm.model) {
          if (
            (elm.fieldType === "RadioButton" &&
              elem.fieldType === "SelectList") ||
            (elm.fieldType === "RadioButton" &&
              elem.fieldType === "RadioButton") ||
            (elm.fieldType === "RadioButton" &&
              elem.fieldType === "SelectList") ||
            (elm.fieldType === "Checkbox" && elem.fieldType === "RadioButton") ||
            (elm.fieldType === "Checkbox" && elem.fieldType === "SelectList") ||
            (elm.fieldType === "SelectList" && elem.fieldType === "SelectList") ||
            (elm.fieldType === "SelectList" && elem.fieldType === "RadioButton")
          ) {
            elem.visible = true;
            elem.disabled = true;
          }
        }
      });
    });

    setcatagory(catagory_array);
    if (res.data.statusCode === 200) {
      setcloneformdata(res.data.data[0].others);
    }
    let teamdata = JSON.parse(localStorage.getItem("Teaminfo"))
    if (Object.keys(teamdata).length > 0) {
      if (teamdata.type == "all" || teamdata.type == "source") {
        let sourcedata = teamdata.type_data.source.map((elm) => {
          return { label: elm.name, value: elm.name }
        })
        if (sourcedata.length > 0) {
          setsource(sourcedata)
        } else {
          sourcefn()
        }

      } else {
        sourcefn()
      }

    } else {
      sourcefn()
    }
  }

  const closepopup = (data) => {
    setpopupdata(data);
    localStorage.removeItem('erroraction_popup')
    console.log("5544444444444444444");
    if (state_value.background.triggerdispo) {
      Dispatch(triggerdispostate(false));
    }
    mounted();
  };

  const requireclosepopup = (data) => {
    console.log("5611111111111111");
    localStorage.setItem("erroraction_popup", true)
    setrequiredpopupdata(data);
  };

  const requireddialogopen = (data) => {
    setrequiredpopupdata((set) => {
      set.open = data;
      return {
        ...set,
      };
    });
  };
  const dialogopen = (data) => {
    console.log("5777777777777777");
    localStorage.removeItem('erroraction_popup')
    setpopupdata((set) => {
      set.open = data;
      return {
        ...set,
      };
    });
  };

  function update(data) {
    console.log("rrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr")
    if (leadcreatestatus === true) {
      let list_id = 0
      let payload = {
        template_name: templetedata.template_name,
        fields: updatedata.fields,
      };

      let count = 0;
      for (let i = 0; i < customField.length; i++) {
        const element = customField[i];
        let tempcount = 0;
        if (
          element.required === true &&
          element.visible === true &&
          element.show_on_popup === true
        ) {
          for (let j = 0; j < updatedata.fields.length; j++) {
            const element1 = updatedata.fields[j];
            let campaigndata = localStorage.getItem('campaigndetails')
            if (element1.name === 'list_id' && element1.value === "" && (JSON.parse(campaigndata).primary_list !== null || JSON.parse(campaigndata).primary_list !== "")) {
              element1.value = JSON.parse(campaigndata).primary_list
              list_id = JSON.parse(campaigndata).primary_list
            } else if (element1.name === 'list_id' && element1.value !== "") {
              list_id = element1.value
            }
            if (element1.name === element.model) {
              let value = element1.value;
              if (value === "" || value === undefined) {
                tempcount += 1;
              }
            }
          }
        }
        count += tempcount;
      }
      if (count > 0) {
        Dispatch(triggerdispostate(true));
        setvalidate(true);

        requireddialogopen(true);
      } else {
        setvalidate(false);

        Dispatch(CustomFormCreate(payload))
          .then((response) => {
            if (response.statusCode === 201) {
              EventEmitter.emit("error-message-getter", {
                action: "createform",
                module: "lead",
              });
              let res = {
                data: {
                  data: response.data[0]
                }
              }

              if (state_value.background.socket_message.phonenumber !== undefined && state_value.background.socket_message.phonenumber.toString() === res.data.data.phone_number) {
                
                let leadData = {
                  lead_id: res.data.data.lead_id,
                  lead_name: res.data.data.first_Name,
                  phone_number: res.data.data.phone_number,
                  render: 1,
                  module: "lead",
                  list_id: list_id
                }
                localStorage.setItem("oncalldata", JSON.stringify(leadData))
                // props.fetchapi()
                Dispatch(callLeadDetail(leadData))
                if (data) {
                  triggerCallScreenFunction(true);
                }
                // EventEmitter.emit("give_dispo_oncreate", {
                //   data:data
                // });
                navigate(`/leads/${Encode(res.data.data.phone_number)}/${res.data.data.lead_id}`)
              } 
             
              else {
                console.log("uuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuoooooooooooooo")
                navigate(`/leads/${Encode(res.data.data.phone_number)}/${res.data.data.lead_id}`)
              }
              if (data === undefined) {
                dialogopen(true);
              }
            }


          })
          .catch((err) => {
            console.log(err, "error in update function")

            EventEmitter.emit("error-message-getter", {
              action: "create",
              module: "lead",
            });
          });
      }
    } else {
      let count = 0;
      for (let i = 0; i < customField.length; i++) {
        const element = customField[i];
        let tempcount = 0;
        if (
          element.required === true &&
          element.visible === true &&
          element.show_on_popup === true
        ) {
          for (let j = 0; j < updatedata.fields.length; j++) {
            const element1 = updatedata.fields[j];
            if (element1.name === element.model) {
              if (state_value.background.socket_message.evt !== "RINGING" && state_value.background.socket_message.calltype === "AUTO") {
                if (element1.name === "user" && element1.value != localStorage.getItem("user") && !element1.value.includes(localStorage.getItem("user"))) {
                  if (element1.value != "" && element1.value != null) {
                    element1.value = `${element1.value},${localStorage.getItem("user")}`
                  } else {
                    element1.value = localStorage.getItem("user")
                  }
                }
              }
              let value = element1.value;
              if (value === "") {
                tempcount += 1;
              }
            }
          }
        } else if (element.model == "user" && state_value.background.socket_message.evt !== "RINGING" && state_value.background.socket_message.calltype === "AUTO") {
          for (let j = 0; j < updatedata.fields.length; j++) {
            const element1 = updatedata.fields[j];
            if (element1.name === element.model) {
              if (element1.name === "user" && element1.value != localStorage.getItem("user") && !element1.value.includes(localStorage.getItem("user"))) {
                if (element1.value != "" && element1.value != null) {
                  element1.value = `${element1.value},${localStorage.getItem("user")}`
                } else {
                  element1.value = localStorage.getItem("user")
                }
              }

              let value = element1.value;
              if (value === "") {
                tempcount += 1;
              }
            }
          }
        }
        // updatedata.fields.forEach((elm)=>{
        //   if(elm.name ==  "sms_notify"){
        //     elm.value = '0'
        //   }
        //   if(elm.name == "wa_notify"){
        //     elm.value = '0'
        //   }
        //   if(elm.name == "email_notify"){
        //     elm.value = '0'
        //   }
        //   if(elm.name == "api_push"){
        //     elm.value = '0'
        //   }
        // })
        count += tempcount;
      }
      if (count > 0) {
        setvalidate(true);
        requireddialogopen(true);
      }
      else {
        let network_status = state_value.background.networkstatus
        if (network_status == "online") {
          Dispatch(triggerdispostate(true));
          setvalidate(false);

          Dispatch(CustomformUpdate(updatedata, templetedata))
            .then(function (res) {
              if (res.statusCode === 200) {
                let conditionvalue = res.data[0]?.condition
               
                let updateData = res.data[0]?.updateData
                updateData.phone_number=updateData?.phone_number.toString()
                setmodeltype_ph_num((set) => {
                  for (let index = 0; index < updatedata.fields.length; index++) {
                    const element = updatedata.fields[index];
                    if (set.indexOf(element.name) != -1 && element.value != "") {
                      let index = set.indexOf(element.name)

                      set.splice(index, 1)
                    }
                  }
                  return set
                })
                if (data === undefined) {
                  dialogopen(true);
                }
                props.fetchapi()
                if (state_value.background.socket_message.phonenumber !== undefined && state_value.background.socket_message.phonenumber.toString() === updateData?.phone_number) {
                  
                  let leadData = {
                    lead_id: conditionvalue?.lead_id,
                    lead_name: updateData?.first_name,
                    phone_number: updateData?.phone_number,
                    render: 1,
                    module: "lead",
                    list_id: updateData.list_id===undefined?0:updateData.list_id
                  }
                  localStorage.setItem("oncalldata", JSON.stringify(leadData))
                 
                  Dispatch(callLeadDetail(leadData))

                }
                if (data) {
                  triggerCallScreenFunction(true);
                }

                // EventEmitter.emit("give_dispo", {
                //   data:data
                // });
              } else {
                if (data === undefined) {
                  dialogopen(true);
                }
                props.fetchapi()
                if (data) {
                  triggerCallScreenFunction(true);
                }
                console.log("204 not updated", "error in update function")

              }

            })
            .catch((err) => {
              console.log(err, "error in update function", updatedata, templetedata)
              EventEmitter.emit("error-message-getter", {
                action: "update",
                module: "customform",
              });
            });

        }


      }
    }

    props.saveleaddetail(false);
  }

  const linkedupadate = (linkedres, parentval, selectedval) => {
    if (linkedres.length > 0) {
      let filterdata;
      linkedres.forEach((elem) => {
        filterdata = customField.map((elm) => {
          if (elm.model === elem.model) {
            if (parentval.fieldType === "RadioButton") {
              elm.disabled = false;
              elm.visible = true;
            } else if (parentval.fieldType === "Checkbox") {
              if (selectedval.checked === "true") {
                elm.disabled = false;
                elm.visible = true;
              } else {
                if (elm.link_property.hasOwnProperty("map") != true) {
                  elm.disabled = true;
                } else {
                  elm.visible = false;
                }
                formdata[`${elm.model}`] = "";
              }
            } else if (parentval.fieldType === "SelectList") {
              elm.disabled = false;
              elm.visible = true;
            }

            if (elm.link_property.hasOwnProperty("map") != true) {
              for (const property in elm.link_property) {
                if (selectedval.value === property) {
                  let split_linkedprop = elm.link_property[property].split(",");
                  let update_linked = split_linkedprop.map((elm) => {
                    return { name: elm, value: elm };
                  });
                  elm.values = [JSON.stringify(update_linked)];
                }
              }
            }
          }
          return elm;
        });
      });
      setcustomField(filterdata);
    }
  };

  function handleChangedata(parentval, data) {
    if (
      parentval.link_type === "Parent" &&
      parentval.linked_to === "" &&
      parentval.is_link === true
    ) {
      let linkedres = customField.filter((elm) => {
        if (elm.linked_to === parentval.model) {
          if (
            elm.link_property.map !== data.value &&
            elm.link_property.hasOwnProperty("map")
          ) {
            elm.visible = false;
            formdata[`${elm.model}`] = "";
          } else if (elm.link_property.map === data.value) {
            return elm;
          } else if (elm.link_property.hasOwnProperty("map") != true) {
            return elm;
          }
        }
      });

      linkedupadate(linkedres, parentval, data);
    }

    setformdata((set) => {
      if (data.isclosed === true) {
        set[`isclosed`] = "true";
      } else {
        set[`isclosed`] = "false";
      }
      if (parentval.fieldType === "RadioButton") {
        set[`${parentval.model}`] = data.value;
      } else if (parentval.fieldType === "Checkbox") {
        set[`${parentval.model}`] = data.checked;
      } else if (
        parentval.fieldType == "SelectList" &&
        parentval.multiple == true
      ) {
        if (Array.isArray(data)) {
          if (parentval.readonly) {
            set[`${parentval.model}`] = set[`${parentval.model}`];
          } else {
            let mergeselect_vals = data.map((elm) => elm.value).toString();
            set[`${parentval.model}`] = mergeselect_vals;
          }
        } else {
          set[`${parentval.model}`] = data.value;
        }
      } else {
        console.log("uuuuuuuuuuuuuuuuuuuuuuuuuuuu", data.value)
        set[`${parentval.model}`] = data.value;
        console.log("uuuuuuuuuuuuuuuuuuuuuuuuuuuu", data.value, set, parentval)
      }

      return {
        ...set,
      };
    });
  }
  function gettextareavalue(value, model, model_type) {
    let Istext = false
    let Sizetext = 0
    if (model_type === "BigText") {
      Istext = true
      Sizetext = 255
    } else if (model_type === "Text") {
      Istext = true
      Sizetext = 60
    } else if (model_type === "LongText") {
      Istext = false
      Sizetext = 0
    }
    let count = value.split("").length
    if (Sizetext - count <= Sizetext && Sizetext - count >= 0 && Istext) {
      settextcount((set) => {
        set[`${model}`] = Sizetext - count
        return {
          ...set
        }
      })
      setformdata((set) => {
        set[`${model}`] = value;
        return { ...set };
      })
    } else {
      setformdata((set) => {
        set[`${model}`] = value;
        return { ...set };
      })
    }
  }
  function fieldType(model_type) {
    let Istext = false
    let Sizetext = 0
    if (model_type === "BigText") {
      Istext = true
      Sizetext = 255
    } else if (model_type === "Text") {
      Istext = true
      Sizetext = 60
    } else if (model_type === "LongText") {
      Istext = false
      Sizetext = 0
    }
    return { Istext, Sizetext }
  }
  let textinputchange = (parentval, data) => {
    if (parentval.type == "input") {
      parentval.type = "others"
    }
    let val = Regex_(parentval.type)
    let otherval = false
    if (parentval.type === "others") {
      if (parentval.model_type === "SmallNumber" || parentval.model_type === "Number" || parentval.model_type === "BigNumber") {
        val = Regex_("number")
      } else {
        otherval = true
      }
    }

    if (data.value === "" || (parentval.type === "others" && otherval)) {
      regexvalidation[`${parentval.model}`] = false
      setregexvalidation((set) => {
        set[`${parentval.model}`] = false
        return {
          ...set
        }
      })
      props.regexval(Object.values(regexvalidation).every((condition) =>
        condition === false
      ))
    }
    else if (!val.test(data.value) || /^(\d)\1*$/.test(data.value)) {
      regexvalidation[`${parentval.model}`] = true
      setregexvalidation((set) => {
        set[`${parentval.model}`] = true
        return {
          ...set
        }
      })
      props.regexval(Object.values(regexvalidation).every((condition) =>
        condition === false
      ))
    } else {
      regexvalidation[`${parentval.model}`] = false
      setregexvalidation((set) => {
        set[`${parentval.model}`] = false
        return {
          ...set
        }
      })
      props.regexval(Object.values(regexvalidation).every((condition) =>
        condition === false
      ))
    }
    setformdata((set) => {
      set[`${parentval.model}`] = data.value;

      return {
        ...set,
      };
    });
  };

  let SelectedGetData = (val) => {
    console.log(val, "val.modelval.modelval.model")
    let select_options = JSON.parse(val.values[0]);
    if (val.multiple != true) {
      if (
        formdata[`${val.model}`] === "" ||
        formdata[`${val.model}`] === null
      ) {
        return null;
      } else {
        if (val.model == "list_id") {
          let listdatas = Listdata.find(
            (elm) => elm.value == formdata[`${val.model}`]
          );
          return {
            value: listdatas.value,
            label: listdatas.label,
          };
        }
        if (val.model == "source") {
          let listdatas = source.find(
            (elm) => elm.value == formdata[`${val.model}`]
          );
          if (listdatas !== undefined) {
            return {
              value: listdatas.value,
              label: listdatas.label,
            };
          } else {
            return null
          }

        }
        if (val.model == "timezone") {
          let timezonedata = timezone.find(
            (elm) => elm.value == formdata[`${val.model}`]
          );
          if (timezonedata !== undefined) {
            return {
              value: timezonedata.value,
              label: timezonedata.label,
            };
          } else {
            return null
          }

        }
        if (val.model == "disposition") {
          let dispositiondata = dispo.find(
            (elm) => elm.value == formdata[`${val.model}`]
          );
          if (dispositiondata !== undefined) {
            return {
              value: dispositiondata.value,
              label: dispositiondata.label,
            };
          } else {
            return null
          }

        }
        if (val.model == "lead_status") {

          let leadstatus_ = leadstatus.find(
            (elm) => elm.value == formdata[`${val.model}`]
          );
          // return {
          // value: leadstatus_.value,
          // label: leadstatus_.label,
          // };
          if (leadstatus_ == undefined) {
            return null
          } else {
            return {
              value: leadstatus_.value,
              label: leadstatus_.label,
            }
          }
        }
        if (val.model == "associated_id") {

          let associated_id = loadvalues.find(
            (elm) => elm.value == formdata[`${val.model}`]
          );

          if (associated_id == undefined) {
            return null
          } else {
            return {
              value: associated_id.value,
              phone_number: associated_id.phone_number,
              label: associated_id.label,
            }
          }
        }
        else {

          let res_val = select_options.find(
            (elm) => elm.value == formdata[`${val.model}`]
          );

          if (res_val == undefined) {
            return null;
          } else {

            return {
              value: res_val.value,
              label: res_val.name,
            };
          }
        }
      }
    } else {
      let final_res;
      if (
        formdata[`${val.model}`] !== "" && formdata[`${val.model}`] !== null &&
        formdata &&
        Object.keys(formdata).length > 0
      ) {
        console.log(formdata, val.model, "val.modelval.modelval.model")
        let splited_data = formdata[`${val.model}`].split(",");
        final_res = splited_data.map((elem) => {
          if (val.model === 'tags') {
            let res_val = tags.find((elm) => elm.value == elem)
            if (res_val == undefined) {
              return null
            } else {
              return {
                value: res_val.value,
                label: res_val.label,
              }
            }
          } else {
            let res_val = select_options.find((elm) => elm.value == elem);
            if (res_val == undefined) {
              return null
            }
            return {
              value: res_val.value,
              label: res_val.name,
            };
          }

        });
      } else {
        final_res = [];
      }

      return final_res;
    }
  };

  let DateGetData = (type, model) => {
    if (type == 'DatePicker') {
      if (formdata[model] == null || formdata[model] == '') {
        return formdata[model]
      } else {
        if (formdata[model] == '0000-00-00 00:00:00') {
          return null;
        }
        else if (formdata[model] == '0000-00-00') {
          return null;
        } else {
          return new Date(formdata[model])
        }

      }
    } else if (type == 'TimePicker') {
      return formdata[model]
    }
  }

  function setuserdate(val, fieldata) {
    if (val === null) return;
    const today = val;
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1;
    let dd = today.getDate();

    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;

    const formattedToday = yyyy + "-" + mm + "-" + dd;
    setformdata((set) => {
      set[`${fieldata.model}`] = formattedToday;

      return {
        ...set,
      };
    });
  }

  const onTimeChanges = (val, fieldata) => {
    fieldata = val.val
    let { hour, minute, meridiem } = val;
    let timevalue = `${hour}:${minute}`;
    setformdata((set) => {
      set[`${fieldata.model}`] = timevalue;

      return {
        ...set,
      };
    });
  };

  const DateTimeGetData = (datetime_return, model) => {

    if (datetime_return) {
      if (!formdata[model] || formdata[model] === '' || formdata[model] === '0000-00-00 00:00:00') {
        return null;
      } else {
        const dateTime = moment(formdata[model], 'YYYY-MM-DD HH:mm:ss');
        if (!dateTime.isValid()) {
          console.log("DateTimeGetData: Invalid date format");
          return null;
        } else {
          const formattedTime = dateTime.format('HH:mm');
          return formattedTime;
        }
      }
    } else {
      if (!formdata[model] || formdata[model] === '' || formdata[model] === '0000-00-00 00:00:00') {
        return null;
      } else {
        const dateTime = moment(formdata[model], 'YYYY-MM-DD HH:mm:ss');
        if (!dateTime.isValid()) {
          console.log("DateTimeGetData: Invalid date format");
          return null;
        } else {
          return dateTime.toDate();
        }
      }
    }
  };

  const onDateTimeChanges = (datetime_return, data_val, fieldval) => {
    if (datetime_return) {
      let datetime = new Date();
      datetime.setHours(parseInt(data_val.hour), parseInt(data_val.minute), 0);

      if (formdata[fieldval.model] == "" || formdata[fieldval.model] == null) {
        setformdata((set) => {
          set[`${fieldval.model}`] = datetime.toISOString();

          return {
            ...set,
          };
        });
      } else {
        let updatetime = new Date(formdata[fieldval.model]);
        updatetime.setHours(
          parseInt(data_val.hour),
          parseInt(data_val.minute),
          0
        );
        setformdata((set) => {
          set[`${fieldval.model}`] = datetime.toISOString();

          return {
            ...set,
          };
        });
      }
    } else {
      const yyyy = data_val.getFullYear();
      let mm = data_val.getMonth() + 1;
      let dd = data_val.getDate();

      if (dd < 10) dd = "0" + dd;
      if (mm < 10) mm = "0" + mm;

      const formattedToday = yyyy + "-" + mm + "-" + dd;
      if (formdata[fieldval.model] == "" || formdata[fieldval.model] == null) {
        handleChangedata(fieldval, { value: data_val });
      } else {
        let updatetime = new Date(formdata[fieldval.model]);
        updatetime.setFullYear(yyyy, mm, dd);
        handleChangedata(fieldval, { value: data_val });
      }
    }
  };
  async function getcontactbyid(id = "") {
    console.log("8888888888888888888888888888888888888", id)
    let url = `/commonsearch?module=contact`
    let payload = {
      "search_value": id,
      "fields": "id",
      "skip": 0,
      "take": 10
    }
    try {
      let response = await Dispatch(Getsearch(url, payload));

      if (response.statusCode === 200) {
        let values = response.data[0];
        return [values];
      } else {
        return []
      }
    } catch (error) {
      console.log(error, "error in getcontactbyid function")
      EventEmitter.emit('error-message-getter', {
        action: 'fetch',
        module: 'common search',
      })
    }

  }
  function objectConverter(val) {
    let arr = JSON.parse(val.values[0]);
    if (val.fieldType === "RadioButton") {
      return (
        <>
          {arr.map((res, i) => {
            return (
              <Form.Check
                key={val.model + i + Math.round(Math.random() * 100).toString()}
                value={formdata[`${val.model}`]}
                disabled={val.disabled || val.readonly}
                onChange={() => handleChangedata(val, res)}
                checked={res.value === formdata[`${val.model}`]}
                type="radio"
                label={res.name}
              />
            );
          })}
        </>
      );
    } else if (val.fieldType === "Checkbox") {
      let val_ = formdata[`${val.model}`];
      return (
        <Form.Check
          key={val.model + Math.round(Math.random() * 100).toString()}
          value={formdata[`${val.model}`]}
          disabled={val.disabled || val.readonly}
          onChange={(e) =>
            handleChangedata(val, {
              checked: e.target.checked.toString(),
              value: val.model,
            })
          }
          type="checkbox"
          checked={val_ == "true"}
          label={`${val.label}`}
        />
      );
    } else {
      let default_value = [];
      let option_arr = [];
      for (let i = 0; i < arr.length; i++) {
        const element = arr[i];
        let obj = {};
        let default_val = {};
        obj["value"] = element.value;
        obj["label"] = element.name;
        option_arr.push(obj);
        if (formdata[`${val.model}`] === element.value) {
          default_val["value"] = element.value;
          default_val["label"] = element.name;
          default_value.push(default_val);
        }
      }
      return (
        <>
          <Select
            key={val.model + Math.round(Math.random() * 100).toString()}
            isMulti={val.multiple}
            isDisabled={val.disabled}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            menuPortalTarget={document.body}
            menuShouldScrollIntoView={false}
            onChange={(e) => handleChangedata(val, e)}
            value={SelectedGetData(val)}
            options={val.model == 'disposition' ? dispo : val.model == 'timezone' ? timezone : val.model == 'tags' ? tags : val.model == "list_id" ? Listdata : val.model == "lead_status" ? leadstatus : val.model == "source" ? source : option_arr}
            isSearchable={true && val.readonly ? false : true}
            menuIsOpen={val.readonly ? false : undefined}
            placeholder={val.placeholder}
            menuPlacement={`auto`}
          />
        </>
      );
    }
  }

  function timer(data) {
    let val = data.val;
    let datetime = data.datetime;
    if (datetime) {
      onDateTimeChanges(true, data, val);
    } else {
      onTimeChanges(data, val);
    }
  }
  function openchatbox(data) {
    setchatdata(data)
  }
  function closeMsgpopup() {
    setchatdata({})
  }
  const promiseOptions = async (inputValue) =>

    new Promise(async (resolve) => {
      setTimeout(() => {
        let url = `/commonsearch?module=contact`
        let payload = {
          "search_value": inputValue,
          "fields": "name",
          "skip": 0,
          "take": 10
        }
        console.log("8888888888888888888888888888888888888", inputValue)
        Dispatch(Getsearch(url, payload))
          .then(async (response) => {
            if (response.statusCode === 200) {
              let values = response.data
              let arr = []
              for (let i = 0; i < values.length; i++) {
                const element = values[i];
                arr.push({ phone_number: element.phone_number, label: element.name, value: element.id })

              }
              if (formdata[`${'associated_id'}`] !== null && formdata[`${'associated_id'}`] !== "") {
                let id = await getcontactbyid(formdata[`${'associated_id'}`])
                if (id.length > 0) {
                  arr.push({ phone_number: id[0].phone_number, label: id[0].name, value: id[0].id })
                }
              }

              setloadvalues(arr)
              resolve(arr);
            } else {

              resolve([]);
            }
          })
          .catch((err) => {
            console.log(err, "error in promiseOptions function")
            EventEmitter.emit('error-message-getter', {
              action: 'fetch',
              module: 'ticket',
            })
          })
      }, 500);
    });

  const datetime_comp = (res, i) => {
    try {
      let min = ""
      let max = ""
      if (res.datelimit === true) {
        if (res.datelimitdata.value == "today") {
          min = currenttime_provider("", { increase: 0, mode: "today" })
          max = ""
        }
        if (res.datelimitdata.value == "weak") {
          min = currenttime_provider("", { increase: 0, mode: "firstDayOfWeek" })
          max = currenttime_provider("", { increase: 0, mode: "lastDayOfWeek" })
        }
        if (res.datelimitdata.value == "yesterday") {
          min = currenttime_provider("", { increase: 0, mode: "yesterday" })
          max = ""
        }
        if (res.datelimitdata.value == "month") {
          min = currenttime_provider("", { mode: "firstDayOfMonth" })
          max = currenttime_provider("", { mode: "lastDayOfMonth" })
        }
        if (res.datelimitdata.value == "year") {
          min = currenttime_provider("", { mode: "firstDayOfYear" })
          max = currenttime_provider("", { mode: "lastDayOfYear" })
          console.log(min, max, "comming");
        }
        if (res.datelimitdata.value == "date_betwn") {
          min = currenttime_provider(res.datelimitdata.limit[0])
          max = currenttime_provider(res.datelimitdata.limit[1])
        }
        if (res.datelimitdata.value == "curr_date_after") {
          min = currenttime_provider("", { increase: 0, mode: "today" })
          max = currenttime_provider("", { increase: res.datelimitdata.limit - 1, mode: "today" })
        }
        if (res.datelimitdata.value == "curr_date_before") {
          min = currenttime_provider("", { increase: -(res.datelimitdata.limit - 1), mode: "today" })
          max = currenttime_provider("", { increase: 0, mode: "today" })
        }
        if (res.datelimitdata.value == "date_before") {
          min = currenttime_provider("", { increase: -(res.datelimitdata.limit - 1), mode: "today" })
          max = ""
        }
        if (res.datelimitdata.value == "date_after") {
          min = currenttime_provider("", { increase: res.datelimitdata.limit, mode: "today" })
          max = ""
        }

        if (min != "") {
          min = new Date(min)
        }

        if (max != "") {
          max = new Date(max)
        }
      }

      return (
        <>
          <DatePicker
            key={res.model + i + i + i.toString()}
            disabled={res.disabled}
            readOnly={res.readonly}
            dateFormat="dd/MM/yyyy"
            selected={DateGetData(
              res.fieldType,
              res.model
            )}
            minDate={min}
            maxDate={max}
            onChange={(date_value) =>
              setuserdate(date_value, res)
            }
            placeholderText={res.placeholder}
            className="form-control"
          />
          {res.required &&
            formdata[`${res.model}`] == "" &&
            validate && (
              <span className="require_class">
                Please Fill Required Field
              </span>
            )}
        </>
      )
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div>
      <Dialogbox
        fields={closepopup}
        value={popupdata}
        defaultclass={"dialog-body-default"}
      />
      <ChatBox formdata={formdata} chatdata={chatdata} closeMsgpopup={closeMsgpopup}></ChatBox>
      <Dialogbox
        fields={requireclosepopup}
        value={requiredpopupdata}
        defaultclass={"dialog-body-default"}
      />
      <div className="Customform-main-view">
        <>
          {catagory.map((resp, i) => {
            return (
              <div>
                {resp && (
                  <>
                    <div
                      className="Customform-catagory"
                      key={resp + i.toString()}
                    >
                      <div className="Customform-catagory-lft">
                        <div
                          className="Customform-category-icon"
                          key={resp + i + i.toString()}
                        >
                          {" "}
                          <BsFillHexagonFill />
                        </div>
                        <div
                          className="Customform-category-title"
                          key={resp + i + i + i.toString()}
                        >
                          {resp}
                        </div>
                      </div>
                    </div>

                    <div
                      className="Customform-body"
                      key={resp + i + i + i + i.toString()}
                    >
                      {customField.filter(res => res.model !== 'disposition').map((res, i) => {
                        return (
                          <>
                            {resp === res.catagory_value &&
                              res.visible == true &&
                              res.show_on_popup == true && (
                                <div
                                  className="Customform-fields"
                                  key={res.model}
                                >
                                  {res.fieldType == 'SelectList' && res.model === "associated_id" && (
                                    <>
                                      <div className="Customform-field-cnt">
                                        <label
                                          className={
                                            res.required
                                              ? 'label_cls required'
                                              : 'label_cls'
                                          }
                                        >
                                          {res.label}{' '}
                                        </label>
                                        {SelectedGetData(res) !== null && <FiNavigation onClick={() => { navigate(`/contact/${Encode(SelectedGetData(res).phone_number)}/${formdata[`${res.model}`]}`) }} />}
                                        <AsyncSelect menuPlacement={`auto`}
                                          onChange={(e) => handleChangedata(res, e)}
                                          value={SelectedGetData(res)}
                                          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                          menuPortalTarget={document.body}
                                          isDisabled={res.disabled}
                                          menuShouldScrollIntoView={false} isMulti={res.multiple} loadOptions={promiseOptions} defaultOptions />
                                        {res.required &&
                                          formdata[`${res.model}`] == '' &&
                                          validate && (
                                            <span className="require_class">
                                              Please fill required fields
                                            </span>
                                          )}
                                      </div>
                                    </>
                                  )}
                                  {res.fieldType == "SelectList" && res.model !== "associated_id" && (
                                    <>
                                      <div
                                        className="Customform-field-cnt"
                                        key={res.model + i.toString()}
                                      >
                                        <label
                                          key={res.model + i + i.toString()}
                                          className={
                                            res.required
                                              ? "label_cls required"
                                              : res.readonly
                                                ? "label_cls readonly"
                                                : "label_cls"
                                          }
                                        >
                                          {res.label}{" "}
                                        </label>
                                        {objectConverter(res)}
                                        {res.required &&
                                          formdata[`${res.model}`] == "" &&
                                          validate && (
                                            <span className="require_class">
                                              Please Fill Required Field
                                            </span>
                                          )}
                                      </div>
                                    </>
                                  )}

                                  {res.fieldType == "TextInput" && (
                                    <>
                                      <div
                                        className="Customform-field-cnt"
                                        key={res.model + i.toString()}
                                      >
                                        <label
                                          key={res.model + i + i.toString()}
                                          className={
                                            res.required
                                              ? "label_cls required"
                                              : res.readonly
                                                ? "label_cls readonly"
                                                : "label_cls"
                                          }
                                        >
                                          {res.label}
                                        </label>
                                        {location.pathname !== '/leads/create' && res.type === "phone_number" && AppPermission.customform_msg && <CiChat2 onClick={() => { openchatbox(res) }} />}
                                        <Form.Control
                                          key={`${res.model}${i}${i}${i}`}
                                          disabled={res.disabled}
                                          onChange={(e) =>
                                            textinputchange(res, { value: e.target.value })
                                          }
                                          value={
                                            formdata[res.model] === undefined
                                              ? ''
                                              : (
                                                (res.type === 'phone_number' && !props.operation && !modeltype_ph_num.includes(res.model)) ||
                                                (localStorage.getItem('setStatic_number') !== null && props.operation && formdata[res.model] !== "") ||
                                                (res.type === 'phone_number' && props.operation && flagnumber && !modeltype_ph_num.includes(res.model))
                                              )
                                                ? fromat(formdata[res.model], { maskbool: true }, true)
                                                : formdata[res.model]
                                          }
                                          className="form-control"
                                          readOnly={
                                            (() => {
                                              const setcampaign = JSON.parse(localStorage.getItem("selectedCampaign_data"));
                                              const isMaskingCampaign = setcampaign.masking === "true";
                                              console.log(isMaskingCampaign,"dataaaaaaaaaaaaaaaaaa1");
                                              console.log(res.model !== 'phone_number',"dataaaaaaaaaaaaaaaaaa2");
                                              if (res.model !== 'phone_number' && !isMaskingCampaign) {
                                                console.log("dataaaaaaaaaaaaaaaaaa4",{ model: res.model, readOnly: true });
                                                return false;
                                              }
                                              return (
                                                ((state_value.background.oncall || flagnumber) && res.type === 'phone_number') ||
                                                (res.type === 'phone_number' && !props.operation)
                                              ) && !modeltype_ph_num.includes(res.model)
                                                ? true
                                                : (localStorage.getItem('setStatic_number') !== null &&
                                                  res.type !== 'phone_number' &&
                                                  !modeltype_ph_num.includes(res.model))
                                                  ? true
                                                  : res.readonly;
                                            })()
                                          }
                                          placeholder={res.placeholder}
                                        />
                                        {res.required &&
                                          formdata[`${res.model}`] == "" || formdata[`${res.model}`] == undefined &&
                                          validate && (
                                            <span className="require_class">
                                              Please Fill Required Field
                                            </span>
                                          )}
                                        {regexvalidation[`${res.model}`] && (
                                          <span className="require_class">
                                            Please Enter Valid {Format('format')}
                                          </span>
                                        )}

                                      </div>
                                    </>
                                  )}
                                  {res.fieldType == "LongTextInput" && (
                                    <>
                                      <label
                                        key={res.model + i.toString()}
                                        className={
                                          res.required
                                            ? "label_cls required"
                                            : res.readonly
                                              ? "label_cls readonly"
                                              : "label_cls"
                                        }
                                      >
                                        {res.label}
                                      </label>
                                      <Form.Control
                                        key={res.model}
                                        disabled={res.disabled}
                                        readOnly={res.readonly}
                                        onChange={(e) =>
                                          gettextareavalue(e.target.value, res.model, res.model_type)
                                        }
                                        value={
                                          formdata[`${res.model}`] === undefined
                                            ? ""
                                            : formdata[`${res.model}`]
                                        }
                                        as="textarea"
                                        placeholder={res.placeholder}
                                      />
                                      {res.required &&
                                        formdata[`${res.model}`] == "" &&
                                        validate && (
                                          <span className="require_class">
                                            Please Fill Required Field
                                          </span>
                                        )}
                                      {textcount[`${res.model}`] === 0 && (
                                        <span className="require_class">
                                          Max Characters {fieldType(res.model_type).Sizetext} Reached
                                        </span>
                                      )}
                                    </>
                                  )}
                                  {res.fieldType == "RadioButton" && (
                                    <>
                                      <div
                                        className="Customform-field-cnt"
                                        key={res.model + i.toString()}
                                      >
                                        {/* {JSON.stringify(res)} */}
                                        <label
                                          key={res.model + i + i.toString()}
                                          className={
                                            res.required
                                              ? "label_cls required"
                                              : res.readonly
                                                ? "label_cls readonly"
                                                : "label_cls"
                                          }
                                        >
                                          {res.label}{" "}
                                        </label>
                                        {objectConverter(res)}
                                        {res.required &&
                                          formdata[`${res.model}`] == "" &&
                                          validate && (
                                            <span className="require_class">
                                              Please Fill Required Field
                                            </span>
                                          )}
                                      </div>
                                    </>
                                  )}
                                  {res.fieldType == "Checkbox" && (
                                    <>
                                      <div
                                        className="Customform-field-cnt"
                                        key={res.model + i.toString()}
                                      >
                                        <label
                                          key={res.model + i + i.toString()}
                                          className={
                                            res.required
                                              ? "label_cls required"
                                              : res.readonly
                                                ? "label_cls readonly"
                                                : "label_cls"
                                          }
                                        >
                                          {res.label}{" "}
                                        </label>
                                        {objectConverter(res)}
                                        {res.required &&
                                          formdata[`${res.model}`] == "" &&
                                          validate && (
                                            <span className="require_class">
                                              Please Fill Required Field
                                            </span>
                                          )}
                                      </div>
                                    </>
                                  )}
                                  {res.fieldType == "DatePicker" && (
                                    <>
                                      <div
                                        className="Customform-field-cnt"
                                        key={res.model + i.toString()}
                                      >
                                        <label
                                          key={res.model + i + i.toString()}
                                          className={
                                            res.required
                                              ? "label_cls required"
                                              : res.readonly
                                                ? "label_cls readonly"
                                                : "label_cls"
                                          }
                                        >
                                          {res.label} {`(YYYY/MM/DD)`}
                                        </label>

                                        {datetime_comp(res, i)}

                                      </div>
                                    </>
                                  )}
                                  {res.fieldType == "TimePicker" && (
                                    <>
                                      <div
                                        className="Customform-field-cnt"
                                        key={res.model + i.toString()}
                                      >
                                        <label
                                          key={res.model + i + i.toString()}
                                          className={
                                            res.required
                                              ? "label_cls required"
                                              : res.readonly
                                                ? "label_cls readonly"
                                                : "label_cls"
                                          }
                                        >
                                          {res.label} {`(HH:MM)`}
                                        </label>
                                        <Timer
                                          key={res.model + i + i + i.toString()}
                                          currentvalue={DateGetData(
                                            res.fieldType,
                                            res.model
                                          )}
                                          disabled={res.disabled}
                                          readOnly={res.readonly}
                                          valuegetter={res}
                                          datetime={false}
                                          minutefinaldata={timer}
                                          hoursfinaldata={timer}
                                        ></Timer>
                                        {res.required &&
                                          formdata[`${res.model}`] == "" &&
                                          validate && (
                                            <span className="require_class">
                                              Please Fill Required Field
                                            </span>
                                          )}
                                      </div>
                                    </>
                                  )}
                                  {res.fieldType == "DatetimePicker" && (
                                    <>
                                      <div
                                        className="Customform-field-cnt"
                                        key={res.model + i.toString()}
                                      >
                                        <label
                                          key={res.model + i + i.toString()}
                                          className={
                                            res.required
                                              ? "label_cls required"
                                              : res.readonly
                                                ? "label_cls readonly"
                                                : "label_cls"
                                          }
                                        >
                                          {res.label} {`(YYYY/MM/DD HH:MM )`}
                                        </label>
                                        <div
                                          className="DatetimePicker"
                                          key={res.model + i + i + i.toString()}
                                        >
                                          {/* <div
                                            className="Datetime_container"
                                            key={
                                              res.model +
                                              i +
                                              i +
                                              i +
                                              i.toString()
                                            }
                                          >
                                            <Timer
                                              key={
                                                res.model +
                                                i +
                                                i +
                                                i +
                                                i +
                                                i.toString()
                                              }
                                              currentvalue={DateTimeGetData(
                                                true,
                                                res.model
                                              )}
                                              disabled={res.disabled}
                                              readOnly={res.readonly}
                                              valuegetter={res}
                                              datetime={true}
                                              minutefinaldata={timer}
                                              hoursfinaldata={timer}
                                            ></Timer>
                                          </div> */}

                                          <div
                                            className="Datetime_container"
                                            key={
                                              res.model +
                                              i +
                                              i +
                                              i +
                                              i +
                                              i +
                                              i.toString()
                                            }
                                          >
                                            <DatePicker
                                              key={
                                                res.model +
                                                i +
                                                i +
                                                i +
                                                i +
                                                i +
                                                i +
                                                i.toString()
                                              }
                                              showTimeSelect
                                              timeIntervals={1}
                                              disabled={res.disabled}
                                              readOnly={res.readonly}
                                              dateFormat="yyyy/MM/d HH:mm"
                                              selected={DateTimeGetData(
                                                false,
                                                res.model
                                              )}
                                              onChange={(date_value) =>
                                                onDateTimeChanges(
                                                  false,
                                                  date_value,
                                                  res
                                                )
                                              }
                                              timeFormat="HH:mm"
                                              placeholderText={res.placeholder}
                                              className="form-control"
                                            />
                                          </div>
                                        </div>
                                        {res.required &&
                                          formdata[`${res.model}`] == "" &&
                                          validate && (
                                            <span className="require_class">
                                              Please Fill Required Field
                                            </span>
                                          )}
                                      </div>
                                    </>
                                  )}
                                </div>
                              )}
                          </>
                        );
                      })}
                    </div>
                  </>
                )}
              </div>
            );
          })}
        </>
      </div>
    </div>
  );
}

export default React.forwardRef(CustomForm);